/**
 * Import Template Configurations for All Modules
 */
export const IMPORT_TEMPLATES = {
  exhibitors: {
    fileName: "sample_exhibitors_import_template.csv",
    headers: [
      // "title",
      "email",
      // "overview",
      // "phone_number",
      // "country",
      // "exhibitor_category",
      // "manager_name",
      // "manager_email",
      // "password",
      // "status",
      // "eco_friendly",
      // "website",
    ],
    sampleData: [
      [
        // "Apex Hospitality Equipment",
        "contact@apexhospitality.com",
        // "Leading manufacturer of commercial kitchen units and food display systems.",
        // "9876543210",
        // "India",
        // "Food & Tech",
        // "Rajesh Kumar",
        // "mgr@apexhospitality.com",
        // "Pass123!",
        // "active",
        // "true",
        // "https://apexhospitality.com",
      ],
      [
        // "EcoClean Solutions",
        "info@ecoclean.com",
        // "Eco-friendly hospitality cleaning supplies and organic detergents.",
        // "9123456789",
        // "IN",
        // "Cleaning",
        // "Priya Sharma",
        // "",
        // "", // Blank password triggers auto-generation
        // "active",
        // "true",
        // "https://ecoclean.com",
      ],
    ],
  },
  products: {
    fileName: "sample_products_import_template.csv",
    headers: [
      "product_name",
      "exhibitor_name",
      "product_category",
      "currency",
      "price",
      "website",
      "short_description",
      "is_sample",
      "sample_start_date",
      "sample_end_date",
      "productImages",
      "default_image",
      "status",
    ],
    sampleData: [
      [
        "Commercial Espresso Machine",
        "Apex Hospitality Equipment",
        "Kitchen Equipment",
        "USD",
        "3500",
        "https://apexhospitality.com",
        "Dual boiler 3-group coffee machine",
        "true",
        "2026-09-01",
        "2026-09-10",
        "https://img.com/1.jpg",
        "https://img.com/1.jpg",
        "active",
      ],
      [
        "Organic Cotton Towels",
        "EcoClean Solutions",
        "Linen",
        "INR",
        "450",
        "https://ecoclean.com",
        "800 GSM plush bath towel set",
        "false",
        "",
        "",
        "https://img.com/2.jpg",
        "https://img.com/2.jpg",
        "active",
      ],
    ],
  },
  offers: {
    fileName: "sample_offers_import_template.csv",
    headers: [
      "title",
      "promo_code",
      "exhibitor_name",
      "target_products",
      "discount",
      "description",
      "start_date",
      "end_date",
      "tc",
      "status",
      "offerImages",
      "default_image",
    ],
    sampleData: [
      [
        "Grand Expo Discount",
        "EXPO2026",
        "Apex Hospitality Equipment",
        "Commercial Espresso Machine",
        "20% OFF",
        "Get 20% off on commercial coffee machines",
        "2026-09-01",
        "2026-09-30",
        "Valid during expo days only",
        "active",
        "https://img.com/offer1.jpg|https://img.com/offer2.jpg",
        "https://img.com/offer1.jpg",
      ],
      [
        "Bulk Buyer Savings",
        "BULK50",
        "EcoClean Solutions",
        "Organic Cotton Towels",
        "$50 OFF",
        "Special bulk discount for hotel orders",
        "2026-09-01",
        "2026-09-15",
        "Minimum order 100 sets",
        "active",
        "https://img.com/offer3.jpg",
        "https://img.com/offer3.jpg",
      ],
    ],
  },
  // Easily extendable for other modules
  visitors: {
    fileName: "sample_visitors_import_template.csv",
    headers: ["name", "email", "phone", "company"],
    sampleData: [["John Doe", "john@example.com", "9876543210", "Acme Corp"]],
  },
};
